import React, { useState, useRef, useEffect } from 'react';
import { Box, TextField } from '@mui/material';

const OTPInput = ({ onOtpChange, isDark = true }) => {
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onOtpChange(newOtp.join(''));

      // Move focus to the next input field if value is not empty
      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <Box gap={10}>
      {otp.map((_, index) => (
        <TextField
          className={isDark ? 'darkBackground': 'lightBackground'}
          key={index}
          value={otp[index]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          inputRef={(el) => (inputRefs.current[index] = el)}
          inputProps={{
            maxLength: 1,
            style: { textAlign: 'center' },
          }}
          size='small'
          sx={{ width: '3rem', 
            color: isDark ? 'white' : 'black', mr: '1rem',
            '& .MuiInputBase-input': {
              color: isDark ? 'secondary' : 'black',
            },  
           }}
          
        />
      ))}
    </Box>
  );
};

export default OTPInput;
